import { SxProps } from '@mui/material'

import theme from '../../../../styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    padding: theme.spacing(2),
    borderRadius: '6px',
    backgroundColor: '#F9FAFB'
  } as SxProps,

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  } as SxProps,

  titleText: {
    fontSize: 13,
    fontWeight: 600,
    color: '#1F2937'
  } as SxProps,

  editIcon: {
    color: '#2563EB',
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    minWidth: 'auto',
    '&:hover': { backgroundColor: 'transparent', opacity: 0.7 }
  } as SxProps,

  detailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  } as SxProps,

  detailsContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    alignItems: 'flex-start'
  } as SxProps,

  nameText: {
    fontSize: 12,
    color: '#374151'
  } as SxProps,

  detailText: {
    fontSize: 11,
    color: '#6B7280'
  } as SxProps
}

export default styles
